import { Component, Inject } from '@angular/core';
import { AssignProgramDialogComponent } from '../assign-programs-dialog/assign-programs-dialog.component';
import { CommentsDialogComponent } from '../comments-dialog/comments-dialog.component';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EmployeeCareerProgramService } from '../employee-career-program.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { EmployeeModel } from 'src/app/Models/EmpCareerUser.model';
import { UserCourse, UserTopic } from 'src/app/Models/employeecareerUser-program.model';
import { Location } from '@angular/common';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { CourseCompleteRequest, ProgramCompleteRequest, TopicCompleteRequest } from '../models/course-complete-request.model';
import { InfoDialogComponent } from 'src/app/components/info-dialog/info-dialog.component';

@Component({
  selector: 'app-program-description',
  templateUrl: './program-description.component.html',
  styleUrls: ['./program-description.component.css']
})
export class ProgramDescriptionComponent {

  programDetails: any;
  programName: any;
  courseDetails: any;
  topicDetails: any;

  employeeDetails: EmployeeModel;
  employeeId: Number;
  userId: number;
  progarmId: number;

  course: UserCourse;

  isCourses: boolean = true;
  isProgramCompleted: boolean = false;
  prerequisites: any;

  courseAttachments: any[] = [];

  attachments: any[] = [];
  tempTopic: any;

  programType: number;
  isProgramRequested: any;

  element: any;
  totalTopics: number;
  totalTopicLength: number;
   
  
  constructor(private fb: FormBuilder,
    //  @Inject(MAT_DIALOG_DATA) public data: any=null,
    private route: Router,
    private service: EmployeeCareerProgramService,
    private authService: AuthServiceService,
    private activatedRoute: ActivatedRoute,
    // private service: Myservice,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private location: Location) {
    // this.programType = window.history.state.programType;
    this.programType = Number(sessionStorage.getItem('programType'));
  }

  ngOnInit(): void {
    this.spinner.show();
    this.employeeId = parseInt(localStorage.getItem('Id'));
    this.userId = parseInt(localStorage.getItem('EmpCareerUserID'));
    const storedData = localStorage.getItem('empCareerUserDetails');
    if (storedData) {
      this.employeeDetails = JSON.parse(storedData);
    } else {

    }
    this.progarmId = this.activatedRoute.snapshot.params.id;
    //?this.activatedRoute.snapshot.params.id : this.data?.programid;
    this.getEmployeeProgramDetail();
    //this.isTopTrainings=this.data?.isTopTrainings||false;
  }

  getEmployeeProgramDetail() {    
    this.spinner.show(); 
    this.service.getEmployeeProgramDetail(this.userId, this.progarmId).subscribe((res: any) => {
      if (res) {
        this.programDetails = res;
        this.programName = res.programName;
        this.isProgramCompleted = this.programDetails?.programStatus == 'Completed' ? true : false;
        this.prerequisites = this.programDetails?.courses.prerequisites;
        if (res?.courses) {
          this.courseDetails = res.courses;
          this.totalTopics = 0;
          for (const course of this.courseDetails) {
            this.totalTopics += course.topics.length;
          }
          this.totalTopicLength = 0;
          for (const course of this.courseDetails) {
            for (const topic of course.topics) {
              this.totalTopicLength += topic.topicLength;
            }
          }
          this.courseAttachments = res.courses.attachments;
        }
      }
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
    })
  }

  goToTopics(course) {
    this.isCourses = false;
    this.topicDetails = course.topics;
    this.course = course;
    this.courseAttachments = course.attachments;
  }

  goToCourses() {
    this.course = null;
    this.isCourses = true;
  }

  startTopic(topic: UserTopic) {
    let request: TopicCompleteRequest = new TopicCompleteRequest();
    request.referenceTopicIDs.push(topic.referenceTopicID);
    request.status = 'In Progress';
    request.userID = this.userId;
    request.statusId = 1;
    request.programId = this.progarmId;
    this.spinner.show();
    this.service.startTopic(request).subscribe((res: any) => {
      if (res) {
        topic.topicStatusID = 1;
        this.startCourse();
        this.startProgram();
      }
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
    });
  }

  startCourse() {
    let request: CourseCompleteRequest = new CourseCompleteRequest();
    request.courseIDs.push(this.course.courseID);
    request.status = 'In Progress';
    request.userID = this.userId;
    request.statusId = 1;
    request.programId = this.progarmId
    this.spinner.show();
    this.service.startCourse(request).subscribe((res: any) => {
      if (res) {
        if (this.course) {
          this.courseDetails.forEach(x => {
            if (x.courseID == this.course.courseID) {
              x.courseStatus = 'In Progress';
            }
          })
        }
        this.courseDetails.courseStatusID = 1;
      }
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
    });
    this.startProgram();
  }

  startProgram() {
    if (!this.programDetails.programStatusID || this.programDetails.programStatusID == 3) {
      let request: ProgramCompleteRequest = new ProgramCompleteRequest();
      request.programIDs.push(this.programDetails.programID);
      request.status = 'In Progress';
      request.userID = this.userId;
      request.statusId = 1;
      this.spinner.show();
      this.service.startProgram(request).subscribe((res: any) => {
        if (res) {
          this.programDetails.programStatus = 'In Progress';
          this.programDetails.programStatusID = 1;
        }
        this.spinner.hide();
      }, error => {
        this.spinner.hide();
      });
    }
  }

  markTopicAsCompleted(topic: UserTopic) {
    let request: TopicCompleteRequest = new TopicCompleteRequest();
    request.referenceTopicIDs.push(topic.referenceTopicID);
    request.status = 'Completed';
    request.userID = this.userId;
    request.programId = this.progarmId;
    this.spinner.show();
    this.service.completeTopic(request).subscribe((res: any) => {
      if (res) {
        topic.topicStatusID = 2;
        this.programDetails.programStatus = 'In Progress';
      }
      var x = Array.from(this.course.topics);
      var completedTopicCount = 0;
      x.forEach(y => {
        this.element = y;
        if (this.element.topicStatusID == 2) {
          completedTopicCount = completedTopicCount + 1;
        }
      })
      if (this.course.topics.length == completedTopicCount) {
        this.course.courseStatus = "Completed";
      }
      var y = Array.from(this.programDetails.courses);
      var completedCourseCount = 0;
      y.forEach(course => {
        this.element = course;
        if (this.element.courseStatus == 'Completed') {
          completedCourseCount = completedCourseCount + 1;
        }
      })
      if (this.programDetails.courses.length == completedCourseCount) {
        this.programDetails.programStatus = 'Completed';
        this.isProgramCompleted = true;
      }
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
    });
  }

  submitCourse(course: UserCourse) {
    let request: CourseCompleteRequest = new CourseCompleteRequest();
    request.courseIDs.push(course.courseID);
    request.status = 'Completed';
    request.userID = this.userId;
    request.programId = this.progarmId
    request.attachments = this.attachments.map(x => {
      return {
        name: x.file.name,
        file: x.url
      }
    });
    // this.attachments.forEach(x => {
    //   this.courseAttachments.push(x);
    // })
    this.spinner.show();
    this.service.completeCourse(request).subscribe((res: any) => {
      if (res) {
        course.courseStatus = 'Completed';
        this.courseDetails.courseStatusID = 2;
        course.topics.forEach(topic => {
          topic.topicStatusID = 2;
        })
        if (this.programDetails.programStatus == 'Not Started') {
          this.programDetails.programStatus = 'In Progress';
        }
        var x = Array.from(this.programDetails.courses);
        var completedCourseCount = 0;
        x.forEach(y => {
          this.element = y;
          if (this.element.courseStatus == 'Completed') {
            completedCourseCount = completedCourseCount + 1;
          }
        })
        if (this.programDetails.courses.length == completedCourseCount) {
          this.programDetails.programStatus = 'Completed';
          this.isProgramCompleted = true;
        }

        this.service.getEmployeeProgramDetail(this.userId, this.progarmId).subscribe((res: any) => {
          this.courseAttachments = res?.courses[0]?.attachments;
          this.spinner.hide();
        }, error => {
          this.spinner.hide();
        })

      }
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
    });
  }

  completeProgram() {
    let request: ProgramCompleteRequest = new ProgramCompleteRequest();
    request.programIDs.push(this.programDetails.programID);
    request.status = 'Completed';
    request.userID = this.userId;
    request.attachments = this.attachments.map(x => {
      return {
        name: x.file.name,
        file: x.url
      }
    });
    this.spinner.show();
    this.service.completeProgram(request).subscribe((res: any) => {
      if (res) {
        this.isProgramCompleted = true;
        this.programDetails.programStatus = 'Completed';
        this.courseDetails.forEach(x => {
          var topics = Array.from(x.topics);
          topics.forEach(y => {
            this.tempTopic = y;
            this.tempTopic.topicStatusID = 2;
          });
          x.courseStatus = 'Completed';
        })
      }
      this.spinner.hide();
      const dialogref = this.dialog.open(InfoDialogComponent, {
        data: { message: 'Update the skill in Employee Details Page' }
      })
      dialogref.afterClosed().subscribe(result => {
        if (result) {
          this.route.navigate([`Employee-details/${this.employeeId}`])
        }
      })
    }, error => {
      this.spinner.hide();
    });
  }

  async uploadFile(event: any[], course: UserCourse) {
    this.attachments = [];
    var uploadedFiles = [];
    Array.from(event).map(async (file) => {
      uploadedFiles.push(this.convertFile(file))
    })
    await Promise.all(uploadedFiles).then(res => {
      res.forEach(x => {
        this.attachments?.push(x)
      })
    })
    if (!this.course) {
      this.course = course;
    }
    this.submitCourse(this.course);
  }

  convertFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e: any) => resolve({
        file,
        url: e.target.result
      })
      reader.readAsDataURL(file);
      reader.onerror = error => reject(error);
    })
  }

  goToPrograms() {
    const selectedGrade = window.history.state.selectedGrade;
    window.history.state.prevUrl ? this.route.navigateByUrl(window.history.state.prevUrl, { state: { activeTab: +sessionStorage.getItem('currentTab') || 0, selectedGrade: selectedGrade } }) : this.route.navigateByUrl('Home/employee-career/program-catalogue', { state: { activeTab: +sessionStorage.getItem('currentTab') || 0 } })
  }

  downloadAttachment(attachment) {
    const downloadLink = document.createElement('a');
    const fileName = attachment.name;

    downloadLink.href = attachment.file;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  removeAttachment(attachment: any, employeeCourseTrackID: any) {
    this.spinner.show();
    this.service.removeCertificate(employeeCourseTrackID, attachment).subscribe((res) => {
      const indexOfObject = this.courseAttachments.findIndex(object => {
        return object.id == attachment;
      });
      this.courseAttachments.splice(indexOfObject, 1);
      this.spinner.hide();
    },
      error => { console.log(error); this.toastr.error("Couldn't remove file", 'Try Again'); this.spinner.hide() });



  }

  revokeProgram() {
    var programs = {
      UserId: this.userId,
      ProgramIds: [this.programDetails.programID]
    };
    this.spinner.show();
    this.service.revokeProgram(programs).subscribe(res => {
      if (res) {
        this.isProgramCompleted = false;
        this.programDetails.programStatus = 'Not Started';
        this.courseDetails.forEach(course => {
          course.courseStatus = 'Not Started';
          course.topics.forEach(topic => {
            topic.topicStatusID = 3;
          })
        })
        this.spinner.hide();
      }
    }, error => {
      this.spinner.hide();
    });
  }

  revokeCourse(course) {
    var courses = {
      UserId: this.userId,
      CourseIds: [course.courseID],
      ProgramId: this.progarmId
    };
    this.service.revokeCourse(courses).subscribe(res => {
      if (res) {
        this.spinner.hide();
        course.courseStatus = 'Not Started';
        course.topics.forEach(x => {
          x.topicStatusID = 3;
        })
        this.isProgramCompleted = false;
        this.UpdateProgramStatus();
      }
    }, error => {
      this.spinner.hide();
    });
  }

  revokeTopic(topic) {
    var topics = {
      UserId: this.userId,
      ReferenceTopicIds: [topic.referenceTopicID],
      ProgramId: this.progarmId
    };
    this.service.revokeTopic(topics).subscribe(res => {
      if (res) {
        this.spinner.hide();
        topic.topicStatusID = 3;
        this.UpdateCourseStatus(this.course);
      }
      this.isProgramCompleted = false;
    }, error => {
      this.spinner.hide();
    });
  }

  UpdateProgramStatus() {
    let coursesCount = this.programDetails.courses.length;
    let inProgressStatusCount = 0;
    let completedStatusCount = 0;
    let notStartedStatusCount = 0;
    this.programDetails.courses.forEach(x => {
      if (x?.courseStatus == 'In Progress') {
        inProgressStatusCount += 1;
      }
      if (x?.courseStatus == 'Completed') {
        completedStatusCount += 1;
      }
      if (x?.courseStatus == 'Not Started') {
        notStartedStatusCount += 1;
      }
    });
    if (coursesCount == inProgressStatusCount) {
      this.programDetails.programStatusID = 1;
      this.programDetails.programStatus = 'In Progress';
      this.updateProgram(this.programDetails);
    }
    else if (coursesCount == completedStatusCount) {
      this.programDetails.programStatusID = 2;
      this.programDetails.programStatus = 'Completed';
      this.updateProgram(this.programDetails);
    }
    else if (coursesCount == notStartedStatusCount) {
      this.programDetails.programStatusID = 3;
      this.programDetails.programStatus = 'Not Started';
      this.updateProgram(this.programDetails);
    }
    else {
      this.programDetails.programStatusID = 1;
      this.programDetails.programStatus = 'In Progress';
      this.updateProgram(this.programDetails);
    }
  }

  UpdateCourseStatus(course: any) {
    let topics = course.topics;
    let topicsCount = course.topics.length;
    topics.forEach(y => {
      let inProgressStatusCount = 0;
      let completedStatusCount = 0;
      let notStartedStatusCount = 0;
      var courseTopics = Array.from(topics);
      courseTopics.forEach(x => {
        this.element = x;
        if (this.element?.topicStatusID == 1) {
          inProgressStatusCount += 1;
        }
        if (this.element?.topicStatusID == 2) {
          completedStatusCount += 1;
        }
        if (this.element?.topicStatusID == 3) {
          notStartedStatusCount += 1;
        }
      });
      if (topicsCount == inProgressStatusCount) {
        course.courseStatusID = 1;
        course.courseStatus = 'In Progress';
        this.updateCourse(course);
      }
      else if (topicsCount == completedStatusCount) {
        course.courseStatusID = 2;
        course.courseStatus = 'Completed';
        this.updateCourse(course);
      }
      else if (topicsCount == notStartedStatusCount) {
        course.courseStatusID = 3;
        course.courseStatus = 'Not Started';
        this.updateCourse(course);
      }
      else {
        course.CourseStatusID = 1;
        course.courseStatus = 'In Progress';
        this.updateCourse(course);
      }
    });

    this.UpdateProgramStatus();
  }

  updateCourse(course) {
    var request = new CourseCompleteRequest();
    request.courseIDs = [course.courseID];
    request.status = course.courseStatus;
    request.statusId = course.courseStatusID;
    request.userID = this.userId;
    request.programId = this.progarmId
    this.spinner.show();
    this.service.startCourse(request).subscribe(res => {
      if (res) {

      }
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
    });
  }

  updateProgram(program) {
    var request = new ProgramCompleteRequest();
    request.programIDs = [program.programID];
    request.status = program.programStatus;
    request.statusId = program.programStatusID;
    request.userID = this.userId;
    this.spinner.show();
    this.service.startProgram(request).subscribe(res => {
      if (res) {

      }
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
    });
  }

  search(event: any) {

  }

  onDepartmentChange(data: any) {

  }

  OpenRequestDialog(rerequest : boolean) {
    const dialogRef = this.dialog.open(CommentsDialogComponent, {
      width: '600px',
      height: '250px',
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(({ userComment, update }) => {
      if(!rerequest){
        update ? this.requestProgram(userComment) : '';
      }
      else{
        update ? this.reRequestProgram(userComment) : '';
      }
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
    });
  }
  requestProgram(userComment: string) {
    // this.spinner.show();
    var requestedProgram = {
      UserId: this.userId,
      ProgramId: this.programDetails.programID,
      RequestStatusID: 3,
      Type: 1,
      PracticeID: 0,
      DepartmentID: 0,
      DepartmentPathID: 0,
      EmployeeComments: userComment
    };
    this.service.requestProgram(requestedProgram).subscribe(res => {
      if (res) {
        this.toastr.success('Requested Successfully');
        this.isProgramRequested = true;
        this.programDetails.isRequested = true;
        // this.spinner.hide();
      }
      // this.spinner.hide();
    }, error => {
      this.toastr.error("Couldn't Request", 'Try Again');
      // this.spinner.hide();
    })
  }

  OpenAssignProgramDialog() {
    const dialogRef = this.dialog.open(AssignProgramDialogComponent, {
      width: "70%",
      height:'80%',
      data: this.programDetails,
      autoFocus: false,

    });
  }
  reRequestProgram(userComment: string){
    var requestedProgram = {
      programRequestId : this.programDetails.programRequestId, 
      ProgramID: this.programDetails.programID,
      StatusID: 3,
      UpdatedBy: this.userId, 
      EmployeeComments : userComment,
      isReRequest : true
    };
    
    this.service.updateProgramRequest(requestedProgram, this.employeeId).subscribe(res => {
      if (res) {
        this.toastr.success('Re-Requested Successfully');
        this.isProgramRequested = true;
        this.programDetails.isRequested = true;
        this.getEmployeeProgramDetail();
      }
    }, error => {
      this.toastr.error("Couldn't Re-Request", 'Try Again');
    })
  }

}
